import type { Member, TeamId } from "./types";
export const TEAM_ORDER: TeamId[] = ["maxima", "fuerza", "impulso"];
export const TEAM_NAMES: Record<TeamId, string> = {
  maxima: "Maxima",
  fuerza: "Fuerza",
  impulso: "Impulso",
};
export function primaryTeam(
  member?: Pick<Member, "teamIds">,
): TeamId | undefined {
  return TEAM_ORDER.find((team) => member?.teamIds.includes(team));
}
export function memberGroup(member?: Pick<Member, "teamIds">): string {
  const team = primaryTeam(member);
  return team ? TEAM_NAMES[team] : "Other members";
}
export function compareMembers(
  a: Pick<Member, "name" | "teamIds">,
  b: Pick<Member, "name" | "teamIds">,
): number {
  const rank = (m: Pick<Member, "teamIds">) => {
    const team = primaryTeam(m);
    return team ? TEAM_ORDER.indexOf(team) : TEAM_ORDER.length;
  };
  return rank(a) - rank(b) || a.name.localeCompare(b.name);
}
export { AUTOMATIC_FEE_EXCLUSIONS } from "../functions/src/fee-policy";
